const version = '44';

export default version;
